import store from '@/store';

export default class EmployerRefreshEvent {
  constructor() {}
}
